// navigator.clipboard only exists in a secure context, so plain-http dev hosts (s3.fgu.test) fall back to execCommand.
export async function copyToClipboard(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return copyWithExecCommand(text);
  }
}

function copyWithExecCommand(text) {
  const textarea = document.createElement("textarea");
  textarea.value = text;
  // Fixed, so focusing it does not scroll the page.
  textarea.style.position = "fixed";
  document.body.appendChild(textarea);
  textarea.select();

  try {
    return document.execCommand("copy") !== false;
  } catch {
    return false;
  } finally {
    document.body.removeChild(textarea);
  }
}
